import React from 'react'
import { Card } from 'react-bootstrap'

const AnalyticsPdfNoDataState = () => (
  <Card className="mb-4">
    <Card.Body className="text-center p-5">
      <p className="text-muted">No analytics data available for the selected period</p>
    </Card.Body>
  </Card>
)

export default AnalyticsPdfNoDataState
